import {DocumentDTO} from '../../api/data-contracts'
import Translator from '../common/translate/Translator'

function DocumentApprovalStatus(props: {document: DocumentDTO}) {
  return (
    <div className='text-center'>
      {props.document.approvalStatusId == 3 && (
        <>
          <div className='badge badge-danger'>
            <Translator name='ONAYSIZ' />
          </div>
        </>
      )}
      {props.document.approvalStatusId == 2 && (
        <>
          <div className='badge badge-success'>
            <Translator name='ONAYLI' />
          </div>
        </>
      )}
      {props.document.approvalStatusId == 1 && (
        <>
          <div className='badge badge-warning'>
            <Translator name='ONAY_BEKLIYOR' />
          </div>
        </>
      )}
    </div>
  )
}

export default DocumentApprovalStatus
